import { cn } from "../lib/utils";

/** A small outlined square of color, for legends and color-keyed lists. */
export function ColorSwatch({
  color,
  className,
}: {
  color: string;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-block h-3 w-3 shrink-0 border-2 border-stone-900",
        className,
      )}
      style={{ backgroundColor: color }}
    />
  );
}
